import PageTypeA from "../components/pageTypeA/PageTypeA";
import { pagesDataA } from "../data/pagesData";

const Page4 = () => {
  return (
    <PageTypeA title={pagesDataA[1].title} subtitle={pagesDataA[1].subtitle} image={pagesDataA[1].image} />
  );
};

export default Page4;
